import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageTitle } from 'src/app/messages/interfaces/MessageTitle';
import { MessagesFacade } from 'src/app/messages/_services/messages.facade';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-view-side-messages-titles',
  templateUrl: './view-side-messages-titles.component.html',
  styleUrls: ['./view-side-messages-titles.component.scss']
})
export class ViewSideMessagesTitlesComponent implements OnInit {

  @Input() messagesTitles: MessageTitle; //titles, mini content and date
  @Output() onScrollList = new EventEmitter<any>()
  @Output() onSortTable = new EventEmitter<any>()
  perPage: number = 10;
  page: number = 1;
  infiniteScrollSpinner: boolean = false;
  currentMessageId: number;
  currLang;
  constructor(
    public messageFacade: MessagesFacade,
    private globalService: GlobalService,
    private translate: TranslateService,) {
    this.globalService.getLang().subscribe(lng =>{
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
   }


  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng =>{
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.messageFacade.getCurrentMessage$().subscribe(message => {
      if (message) {
        this.currentMessageId = message[0]?.id;
      }

    })
  }


  onScroll() {
    this.onScrollList.emit(true)
    // this.messageFacade.setCurrentPage()
  }

  sortTable(sortValue) {
    this.onSortTable.emit(sortValue)
  }
}
